module.exports = __webpack_public_path__ + "static/media/study 201118.3c312199.png";